import { breakAfterSlashes } from "@/lib/break-after-slashes";
import { cn } from "@/lib/cn";

interface TeamTagProps {
  className?: string;
  name: string;
  color?: string;
  /** Says what the tag names; a team unless told otherwise. */
  title?: string;
  /** Wraps a long name onto more lines, between words where it can, instead of cutting it off. */
  wrap?: boolean;
}
export const NameTag = (props: TeamTagProps) => {
  const { className, name, color, title = `${name} team`, wrap = false } = props;

  return (
    <span
      className={cn(
        "relative inline-flex max-w-full cursor-default items-center justify-center rounded-sm border border-border bg-background py-0.5 pr-2 text-xs font-semibold text-muted-foreground",
        color ? "pl-4" : "pl-2",
        className,
      )}
      title={title}
    >
      {color && (
        <span
          className="absolute -bottom-px -left-px -top-px block w-3 rounded-l"
          style={{ backgroundColor: color }}
        />
      )}
      <span
        className={cn(
          "block overflow-hidden",
          wrap ? "whitespace-normal wrap-break-word" : "truncate",
        )}
      >
        {wrap ? breakAfterSlashes(name) : name}
      </span>
    </span>
  );
};
